
export const SIZOTSA_UPLOAD_DOCUMENTS =
  "sizotsaFuneralCover/uploadDocuments/";
export const UPLOAD_DOCUMENTS_SET_VALUE =
SIZOTSA_UPLOAD_DOCUMENTS+"setValue/";
export const UPLOAD_DOCUMENTS_SET_VALID =
SIZOTSA_UPLOAD_DOCUMENTS +"setValid/";



export const setSizotsaDocumentValue =(value)=>({type: UPLOAD_DOCUMENTS_SET_VALUE, value})
export const setSizotsaDocumentValid =(error,fileType)=>({type: UPLOAD_DOCUMENTS_SET_VALID, error, fileType})


export const UPLOAD_DOCUMENTS_RESET =
SIZOTSA_UPLOAD_DOCUMENTS +"reset";
export const resetSizotsaDocuments =()=>({type: UPLOAD_DOCUMENTS_RESET})

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;


export const UPLOAD_DOCUMENTS_CONFIG = {

  MIN_INPUT_SIZE: SIZE_1_kb,
  MIN_INPUT_SIZE_NAME: '1 kb',
  MAX_INPUT_SIZE: SIZE_2_MB,
  MAX_INPUT_SIZE_NAME: '2 mb',
  VALID_UPLOAD_TYPES: [
      { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
      {FORMAT: 'image/png', FORMAT_NAME: 'PNG'},
      { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
  ],
};

export const UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE =
SIZOTSA_UPLOAD_DOCUMENTS+"/setPresignedValue";

export const updatePresignedUrl =(value)=>({type: UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE, value})